export default class SecretChatState {
    //密聊会话建立中
    static Starting = 0;

    //密聊会话接受中
    static Accepting = 1;

    //密聊会话已建立
    static Established = 2;

    //密聊会话已取消
    static Canceled = 3;

}
